import { FC } from 'react';
import { Select, Typography } from 'antd';
import type { SelectProps } from 'antd';
import type { VisibilityTypeId } from '#types/System.types';
import FlexCol from '../../atoms/FlexCol';

const { Text } = Typography;

interface VisibilityModeSelectProps {
    selectedMode: VisibilityTypeId;
    options: SelectProps['options'];
    onChange: (value: VisibilityTypeId) => void;
}

const VisibilityModeSelect: FC<VisibilityModeSelectProps> = ({ selectedMode, options, onChange }) => (
    <FlexCol stretch noGap>
        <Text>Select view mode</Text>
        <Select
            value={selectedMode}
            onChange={onChange}
            options={options}
            style={{ width: '100%' }}
            optionRender={(option) => (
                <FlexCol gap={2} alignStart>
                    <Text strong>{option.label}</Text>
                    <Text type="secondary">{option.data?.title ?? option.label}</Text>
                </FlexCol>
            )}
        />
    </FlexCol>
);

export default VisibilityModeSelect;

